"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_crud_client_1 = require("./new.crud.client");
class UserV2Client extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v2/users';
    }
    findUser(userId, fields, includeDeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/${userId}?${this.getQueryString({ fields, includeDeleted })}`);
            return response.payload || {};
        });
    }
    getUserTeam(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { userId } = request, params = __rest(request, ["userId"]);
            const response = yield this.httpGet(`/v2/users/${userId}/teams?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getUserProjects(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { userId } = request, params = __rest(request, ["userId"]);
            const response = yield this.httpGet(`/v2/users/${userId}/projects?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    checkEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost('/v2/users/check-email', { email });
            return response.payload;
        });
    }
    migrateUser(userId, type, entityId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/users/migrate`, { userId, type, entityId });
            return response.payload;
        });
    }
    getCsmsByProjectId(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/csm`);
            return response.payload || [];
        });
    }
    getAllEmployees(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/employees`);
            return response.payload || [];
        });
    }
    isUserLabelMaster(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/users/projects/${projectId}/label-master`);
            return response.payload || false;
        });
    }
}
exports.UserV2Client = UserV2Client;
//# sourceMappingURL=user.v2.client.js.map